import moment from 'moment';
import { Invitation } from '../../../../../redux/invitations/invitation.model';

export const isInviationValid = (invitation: Invitation | undefined) => {
  if (!invitation) return true;

  const currentTime = moment();
  const sentAt = moment(invitation.sentAt * 1000);
  const ttl = invitation.invitationTtlMinutes;
  return currentTime.isBefore(sentAt.add(ttl, 'minutes'));
};

export const isUserActive = (invitation: Invitation | undefined) => {
  return !!invitation?.userActive;
};
